<template>
  <div id="app">
    <Hero/>
    <Portfolio/>
  </div>
</template>

<script>
import Hero from "./components/Hero.vue";
import Portfolio from "./components/Portfolio.vue";

export default {
    name: "app",
    components: {
        Hero,
        Portfolio
    }
};
</script>

<style>
* {
    box-sizing: border-box;
}

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

body {
    margin: 0;
}

img {
    max-width: 100%;
}
</style>
